import { getBackendUrl, getWhatsAppGoUrl } from "../config";

function normalizeRawUrl(value) {
	if (value == null) return "";
	const raw = String(value).trim();
	if (!raw || raw === "null" || raw === "undefined") return "";
	return raw;
}

export function normalizeMediaKey(path) {
	if (!path) return "";
	return String(path)
		.trim()
		.replace(/^https?:\/\/[^/]+/i, "")
		.replace(/^\/api/i, "")
		.replace(/^\/+/, "")
		.replace(/^public\//i, "")
		.replace(/^media\//i, "")
		.replace(/^\/+/, "");
}

export function isAwsS3FrontendEnabled() {
	return String(process.env.REACT_APP_AWSS3 || "").toLowerCase() === "true";
}

/** Base da API que serve mídia: Go (/media + S3) quando AWS; Node/Go /public quando off. */
function getMediaBaseUrl() {
	if (isAwsS3FrontendEnabled()) {
		return (getWhatsAppGoUrl() || "").replace(/\/$/, "");
	}
	return (getBackendUrl() || "").replace(/\/$/, "");
}

/**
 * Monta URL absoluta para mídia.
 * - AWSS3=true → Go /media/{key} (redirect URL assinada ou fallback local)
 * - caso contrário → backend /public/{key}
 */
export function resolveMediaUrl(mediaUrl) {
	const raw = normalizeRawUrl(mediaUrl);
	if (!raw) return "";

	if (/^(blob:|data:)/i.test(raw)) {
		return raw;
	}

	if (raw.startsWith("//")) {
		return `https:${raw}`;
	}

	const nodeBase = (getBackendUrl() || "").replace(/\/$/, "");
	const goBase = (getWhatsAppGoUrl() || "").replace(/\/$/, "");
	const mediaBase = getMediaBaseUrl();

	if (/^https?:\/\//i.test(raw)) {
		const knownBases = [nodeBase, goBase].filter(Boolean);
		const matched = knownBases.find((b) => raw.startsWith(b));
		if (matched) {
			const key = normalizeMediaKey(raw);
			if (!key) return raw;
			if (isAwsS3FrontendEnabled()) {
				return `${mediaBase}/media/${key}`;
			}
			return `${matched}/public/${key}`;
		}
		return raw;
	}

	const key = normalizeMediaKey(raw);
	if (!key) return "";

	if (isAwsS3FrontendEnabled()) {
		return `${mediaBase}/media/${key}`;
	}

	if (String(raw).replace(/^\/+/, "").startsWith("public/")) {
		return `${mediaBase}/${String(raw).replace(/^\/+/, "")}`;
	}
	return `${mediaBase}/public/${key}`;
}

export function resolveProfilePicUrl(profilePicUrl) {
	return resolveMediaUrl(profilePicUrl);
}

/** Key real gravada no S3/multer (`file.filename`); cai no nome local se a resposta vier vazia. */
export function resolveUploadedFileUrl(file, uploadResponse) {
	const key =
		uploadResponse?.data?.file?.filename ||
		uploadResponse?.file?.filename ||
		file?.name;
	return resolveMediaUrl(key);
}

export function normalizeProfilePicS3Key(path) {
	return normalizeMediaKey(path) || null;
}

export function isAbsoluteWebUrl(value) {
	return /^https?:\/\//i.test(normalizeRawUrl(value));
}
